import { DefinedValue, RealDefinedValue } from '@Alternatives/Model';
import VueCqrs from '@cqrs/vue-component-cqrs';
import Component from 'vue-class-component';
import * as c from '@Alternatives/Attributes/Domain/commands-core';

@Component
export default class AttributesCommands extends VueCqrs 
{
	invokeCreateNumericAttributeCommandV1(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue: number | null, maxValue: number | null, script: string | null, definedValues: RealDefinedValue[] | null)
	{
		const cmd = new c.CreateNumericAttributeCommandV1(isCorporate, workspaceId, projectId, alternativesListId, attributeId, internalName, name, description, section, inputType, allowMultipleValues, minValue, maxValue, script, definedValues);
		this.$command(cmd);
	}

	invokeCreateTextAttributeCommandV1(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minLength: number | null, maxLength: number | null, definedValues: DefinedValue[] | null)
	{
		const cmd = new c.CreateTextAttributeCommandV1(isCorporate, workspaceId, projectId, alternativesListId, attributeId, internalName, name, description, section, inputType, allowMultipleValues, minLength, maxLength, definedValues);
		this.$command(cmd);
	}

	invokeCreateDateAttributeCommandV1(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean,
		minValue?: Date | null, maxValue?: Date | null, definedValues?: DefinedValue[] | null)
	{
		const cmd = new c.CreateDateAttributeCommandV1(isCorporate, workspaceId, projectId, alternativesListId, attributeId, internalName, name, description, section, inputType, allowMultipleValues, minValue, maxValue, definedValues);
		this.$command(cmd);
	}

	invokeCreateEmailAttributeCommandV1(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, inputType: string, allowMultipleValues: boolean, definedValues?: DefinedValue[] | null)
	{
		const cmd = new c.CreateEmailAttributeCommandV1(isCorporate, workspaceId, projectId, alternativesListId, attributeId, internalName, name, description, section, inputType, allowMultipleValues, definedValues);
		this.$command(cmd);
	}

	invokeCreateMultilineAttributeCommandV1(isCorporate: boolean, workspaceId: number, projectId: number, alternativesListId: number, attributeId: number, internalName: string | null, name: string, description: string, section: string, rows: number,
		minLength?: number | null, maxLength?: number | null)
	{
		const cmd = new c.CreateMultilineAttributeCommandV1(isCorporate, workspaceId, projectId, alternativesListId, attributeId, internalName, name, description, section, rows, minLength, maxLength);
		this.$command(cmd);
	}


	invokeDeleteAttributeCommandV1(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number)
	{
		const cmd = new c.DeleteAttributeCommandV1(workspaceId, projectId, alternativesListId, attributeId);
		this.$command(cmd, attributeId.toString());
	}
}